import { RootState } from '../../../../../../../../init-store';
import { ContainerDrawer } from '../common-drawers/container-drawer';
import { Area } from '../types';
import { SCALE } from './constants';
import { CONTROLS_HEIGHT, ControlsDrawer } from './controls-drawer';
import { PAGE_STATE_HEIGHT, PageStateDrawer } from './page-state-drawer';
import { PARTICIPANTS_HEIGHT, PARTICIPANTS_WIDTH, ParticipantsDrawer } from './participants-drawer';
import { TITLE_HEIGHT, TitleDrawer } from './title-drawer';

// Title
const TITLE_MARGIN_BOTTOM = Math.round(24 * SCALE);
const TITLE_TOTAL_HEIGHT = TITLE_HEIGHT + TITLE_MARGIN_BOTTOM;

// Participants
const PARTICIPANTS_MARGIN_BOTTOM = Math.round(40 * SCALE);
const PARTICIPANTS_TOTAL_HEIGHT = PARTICIPANTS_HEIGHT + PARTICIPANTS_MARGIN_BOTTOM;

// Page state
const PAGE_STATE_MARGIN_BOTTOM = Math.round(16 * SCALE);
const PAGE_STATE_TOTAL_HEIGHT = PAGE_STATE_HEIGHT + PAGE_STATE_MARGIN_BOTTOM;

// Container
const CONTAINER_PADDING = Math.round(32 * SCALE);
const CONTAINER_WIDTH = PARTICIPANTS_WIDTH + CONTAINER_PADDING * 2;
const CONTAINER_HEIGHT =
    CONTAINER_PADDING + TITLE_TOTAL_HEIGHT + PARTICIPANTS_TOTAL_HEIGHT + PAGE_STATE_TOTAL_HEIGHT + CONTROLS_HEIGHT;

type Drawers = {
    containerDrawer: ContainerDrawer;
    titleDrawer: TitleDrawer;
    participantsDrawer: ParticipantsDrawer;
    pageStateDrawer: PageStateDrawer;
    controlsDrawer: ControlsDrawer;
};

let DRAWERS: Drawers | null = null;

function initDrawers(ctx: CanvasRenderingContext2D): Drawers {
    const containerArea: Area = {
        x: Math.round((ctx.canvas.width - CONTAINER_WIDTH) / 2),
        y: Math.round((ctx.canvas.height - CONTAINER_HEIGHT) / 2),
        width: CONTAINER_WIDTH,
        height: CONTAINER_HEIGHT,
    };
    const containerDrawer = new ContainerDrawer(containerArea);

    const titleArea: Area = {
        x: containerArea.x + CONTAINER_PADDING,
        y: containerArea.y + CONTAINER_PADDING,
        width: containerArea.width - CONTAINER_PADDING * 2,
        height: TITLE_HEIGHT,
    };
    const titleDrawer = new TitleDrawer(titleArea);

    const participantsArea: Area = {
        x: containerArea.x + CONTAINER_PADDING,
        y: titleArea.y + titleArea.height + TITLE_MARGIN_BOTTOM,
        width: containerArea.width - CONTAINER_PADDING * 2,
        height: PARTICIPANTS_HEIGHT,
    };
    const participantsDrawer = new ParticipantsDrawer(participantsArea);

    const pageStateArea: Area = {
        x: containerArea.x + CONTAINER_PADDING,
        y: participantsArea.y + participantsArea.height + PARTICIPANTS_MARGIN_BOTTOM,
        width: containerArea.width - CONTAINER_PADDING * 2,
        height: PAGE_STATE_HEIGHT,
    };
    const pageStateDrawer = new PageStateDrawer(pageStateArea);

    const controlsFullArea: Area = {
        x: containerArea.x,
        y: pageStateArea.y + pageStateArea.height + PAGE_STATE_MARGIN_BOTTOM,
        width: containerArea.width,
        height: CONTROLS_HEIGHT,
    };
    const controlsContentArea: Area = {
        x: containerArea.x + CONTAINER_PADDING,
        y: controlsFullArea.y,
        width: containerArea.width - CONTAINER_PADDING * 2,
        height: CONTROLS_HEIGHT,
    };
    const controlsDrawer = new ControlsDrawer(controlsFullArea, controlsContentArea);

    return {
        containerDrawer,
        titleDrawer,
        participantsDrawer,
        pageStateDrawer,
        controlsDrawer,
    };
}

export function drawParticipantList(ctx: CanvasRenderingContext2D, state: RootState) {
    if (!DRAWERS) {
        DRAWERS = initDrawers(ctx);
    }

    DRAWERS.containerDrawer.draw(ctx);
    DRAWERS.titleDrawer.draw(ctx, state);
    DRAWERS.participantsDrawer.draw(ctx, state);
    DRAWERS.pageStateDrawer.draw(ctx, state);
    DRAWERS.controlsDrawer.draw(ctx, state);
}
